import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../Translator';
import styles from './EmptyView.module.css';

const bindClasses = classNameBind.bind(styles);

// TODO: Need to fix translations here

const EmptyView = ({
  children,
  text,
  t,
}) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="EmptyView"
  >
    <div className={bindClasses('content')}>{text || t('noItemSelected')}</div>
    {children}
  </div>
);

EmptyView.defaultProps = {
  text: '',
  children: null,
};

const enhanced = withTranslation('components')(EmptyView);
enhanced.displayName = 'EmptyView';

export default enhanced;
export const PureComponent = EmptyView;
